
import { PropType, defineComponent } from 'vue';

import { AmountType } from '@/activities/utils/amountsAndUnits/findUnit';
import ButtonLink from '@/shared/components/buttons/ButtonLink.vue';

export default defineComponent({
  name: 'ProductAmountModeSection',
  components: { ButtonLink },
  props: {
    mode: {
      type: String as PropType<AmountType>,
      required: true,
    },
  },
  computed: {
    isTotal(): boolean {
      return this.mode === AmountType.Total;
    },
    description(): string {
      return this.isTotal
        ? this.$t(
            'Die Produktmenge wurde als Gesamtmenge eingegeben. Die Menge pro Hektar hängt von der bearbeiteten Fläche ab.',
          ) ?? ''
        : this.$t(
            'Die Produktmenge wurde pro Hektar eingegeben. Die Gesamtmenge hängt von der bearbeiteten Fläche ab.',
          ) ?? '';
    },
    linkLabel(): string {
      return this.isTotal
        ? this.$t('Klicke hier um die Menge pro Hektar festzulegen.') ??
            'Klicke hier um die Menge pro Hektar festzulegen.'
        : this.$t('Klicke hier um die Gesamtmenge festzulegen.') ?? 'Klicke hier um die Gesamtmenge festzulegen.';
    },
  },
});
